/**
 * Heuristiques légères sur user-agent (aucune base embarquée).
 * @param {string} userAgent
 * @returns {{ os: string; browser: string; device: string }}
 */
export function parseUserAgent(userAgent) {
  const ua = String(userAgent || '');
  if (!ua) {
    return { os: '—', browser: '—', device: '—' };
  }
  const l = ua.toLowerCase();

  let os = 'Autre';
  if (l.includes('windows nt')) os = 'Windows';
  else if (l.includes('android')) os = 'Android';
  else if (l.includes('iphone') || l.includes('ipad') || l.includes('ios')) os = 'iOS';
  else if (l.includes('mac os x') || l.includes('macintosh')) os = 'macOS';
  else if (l.includes('linux')) os = 'Linux';

  let browser = 'Autre';
  if (l.includes('edg/')) browser = 'Edge';
  else if (l.includes('chrome') && !l.includes('chromium')) browser = 'Chrome';
  else if (l.includes('firefox/')) browser = 'Firefox';
  else if (l.includes('safari/') && !l.includes('chrome')) browser = 'Safari';
  else if (l.includes('chromium')) browser = 'Chromium';

  let device = 'Bureau';
  if (l.includes('ipad') || l.includes('tablet')) device = 'Tablette';
  else if (l.includes('iphone') || l.includes('ipod') || (l.includes('android') && l.includes('mobile'))) {
    device = 'Mobile';
  } else if (l.includes('android')) device = 'Autre';

  return { os, browser, device };
}

/**
 * @param {unknown} t
 * @returns {Date | null}
 */
function toDate(t) {
  if (t == null) return null;
  if (t instanceof Date) return Number.isNaN(t.getTime()) ? null : t;
  try {
    const d = new Date(t);
    return Number.isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
}

/**
 * Durée de session en minutes (approximation : pour les entrées inactives,
 * fin = connexion suivante (plus ancienne) dans la liste triée du plus récent au plus vieux).
 */
export function sessionDurationMinutes(session, index, sessions) {
  const login = toDate(
    typeof session?.login_time === 'string' ? session.login_time : session?.login_time
  );
  if (!login) return null;
  if (session?.is_active) {
    return (Date.now() - login.getTime()) / 60000;
  }
  const nextOlder = sessions[index + 1];
  const end = nextOlder?.login_time
    ? toDate(
        typeof nextOlder.login_time === 'string' ? nextOlder.login_time : nextOlder.login_time
      )
    : null;
  if (end) return Math.max(0, (end.getTime() - login.getTime()) / 60000);
  return null;
}
